import { render, staticRenderFns } from "./koshaAccidentDetail.vue?vue&type=template&id=e22900dc"
import script from "./koshaAccidentDetail.vue?vue&type=script&lang=js"
export * from "./koshaAccidentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e22900dc')) {
      api.createRecord('e22900dc', component.options)
    } else {
      api.reload('e22900dc', component.options)
    }
    module.hot.accept("./koshaAccidentDetail.vue?vue&type=template&id=e22900dc", function () {
      api.rerender('e22900dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/acc/koshaAccidentDetail.vue"
export default component.exports